<app-dialog
  #dialog
  [key]="'generate-partner-contract'"
  [action]="'generate-partner-contract'"
  [headerTheme]="'simple'"
  [title]="'Gerar contrato de parceria'"
  [appendTo]="'body'"
  [maxWidth]="'720px'">
  <div class="p-4">
    <p class="generate-contract__intro">
      O contrato sai do <strong>modelo vigente de pessoa jurídica</strong>, já com estes dados no
      lugar das variáveis. Campo em branco fica marcado no texto para preencher depois, no editor.
    </p>

    <app-partner-contract-party-form [form]="form" layout="double" />
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="saving"
        [loadingText]="'Gerando...'"
        [label]="'Gerar contrato'"
        icon="pi pi-file-edit"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
